import React, { useEffect, useRef, useState } from 'react'
import Header from '../Dashboard Components/Header/Header'
import { Outlet, useLocation } from 'react-router-dom'
import './DashboardLayout.scss'

function DashboardLayout() {
  const { pathname, key } = useLocation();
  const navRef = useRef(null);
  const hamburgerRef = useRef(null);
  const [windowSize, windowSizeSet] = useState(null)
  const [state, setState] = useState(false)

  const outsideClickHandler = (e)=>{
    if(navRef.current && state && !navRef.current.contains(e.target) && !hamburgerRef.current.contains(e.target)){
        setState(false)
    }
  }
  const toggleBtn =()=>{
    if(state){
      setState(false)
    }else{
      setState(true)
    }
  }

  useEffect(()=>{
    windowSizeSet(window.innerWidth)
    if(window.innerWidth <=992){
      document.addEventListener("click", outsideClickHandler);
      return () => {
          document.removeEventListener("click", outsideClickHandler);
        };
    }else{
      setState(true)
    }
  },[state])


    // Handle window resize
    useEffect(() => {
      const handleResize = () => {
        const newWidth = window.innerWidth;
        windowSizeSet(newWidth);
        
        // Auto-close nav on mobile, auto-open on desktop
        if (newWidth >= 992) {
          setState(true);
        } else {
          setState(false);
        }
      };
  
      // Set initial state based on window size
      handleResize();
      
      // Add resize listener
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

  
    // Close nav when route changes (optional)
    useEffect(() => {
      if (windowSize < 992) {
        setState(false);
      }
    }, [pathname, windowSize]);


  return (
    <div key={key} className='h-100 d-flex flex-column'>
      <Header toggleBtn={toggleBtn} state={state} navRef={navRef} hamburgerRef={hamburgerRef}/>
      <div className='main-container flex-grow-1'>
        <Outlet/>
      </div>
    </div>
  )
}

export default DashboardLayout